










import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({})
export default class StateStatus extends Vue {
  @Prop()
  isEnter!: boolean
}
